import { useState } from 'react'
import { uniqBy } from 'lodash'

const useSchemaProperties = (_dataElementId) => {
	const [error, setError] = useState()

	const [requiredFields, setRequiredFields] = useState()
	const [optionalFields, setOptionalFields] = useState()
	const [attachmentFields, setAttachmentFields] = useState()

	function getRequiredFieldsSchema(schema) {
		let items = schema.map(x => Object.entries(x.properties)
			.filter((field) => x.required?.includes(field[0]) && field[0] !== 'attachments')
			.map((entry) => ({
				id: entry[0],
				name: entry[1].title ? entry[1].title : entry[1].description,
				description: entry[1].description
			})
		));
		items = items.flat();
		const uniqueData = uniqBy(items, "id");
		setRequiredFields(uniqueData);
		return uniqueData;
	}

	function getRequiredFields(schema) {
		if (schema.anyOf || schema.oneOf) {
			return getRequiredFieldsSchema(schema.anyOf ? schema.anyOf : schema.oneOf);
		}
		if (!schema?.properties) {
			setError('Schema has no properties field')
			return []
		}
		const items = Object.entries(schema.properties)
			.filter((field) => schema.required?.includes(field[0]) && field[0] !== 'attachments')
			.map((entry) => ({
				id: entry[0],
				name: entry[1].title ? entry[1].title : entry[1].description,
				description: entry[1].description
			})
		);
		setRequiredFields(items);
		return items;
	}

	function getOptionalFieldsSchema(schema) {
		let items = schema.map(x => Object.entries(x.properties)
			.filter((field) => !x.required?.includes(field[0]) && field[0] !== 'attachments')
			.map((entry) => ({
				id: entry[0],
				name: entry[1].title ? entry[1].title : entry[1].description,
				description: entry[1].description
			})
		));
		items = items.flat();
		const uniqueData = uniqBy(items, "id");
		setOptionalFields(uniqueData);
		return uniqueData;
	}

	function getOptionalFields(schema) {
		if (schema.anyOf || schema.oneOf) {
			return getOptionalFieldsSchema(schema.anyOf ? schema.anyOf : schema.oneOf);
		}
		if (!schema?.properties) {
			setError('Schema has no properties field')
			return []
		}
		const items = Object.entries(schema.properties)
			.filter((field) => !schema.required?.includes(field[0]) && field[0] !== 'attachments')
			.map((entry) => ({
				id: entry[0],
				name: entry[1].title ? entry[1].title : entry[1].description,
				description: entry[1].description
			})
		);
		setOptionalFields(items);
		return items;
	}

	function getAttachments(schema) {
		if (!schema?.properties) {
			setError('Schema has no properties field')
			return "---"
		}
		const items = schema.properties.attachments
			? new Array(schema.properties.attachments.minItems || 1).fill(
				schema.properties.attachments.items.properties.filename
					.description
			)
			: [];
		const attachment = items.length > 0 ? "This data element supports sending of attachments" : "This data element does not support attachments"
		setAttachmentFields(attachment)
		return attachment
	}

	return {
		requiredFields,
		optionalFields,
		attachmentFields,
		getRequiredFields,
		getOptionalFields,
		getAttachments,
		error
	}
}

export default useSchemaProperties
